import classNames from 'classnames';
import { useRouteMatch } from 'react-router-dom';

import { productDetails } from '@legacyUrls';
import { Button } from '@ui/Button';
import { logger } from '@utils/logger';

import s from './ProductSizeSelect.sss';

interface MatchParams {
  productId: string,
}

export interface Size {
  id: number,
  name: string,
}

interface Props {
  className?: string,
  sizes: Size[],
  selectedSizesIds: number[],
  onSelectSize: (sizeId: number) => void,
}

export const ProductSizeSelect: React.FC<Props> = ({
  className,
  sizes,
  selectedSizesIds,
  onSelectSize,
}) => {
  const match = useRouteMatch<MatchParams>(productDetails);
  const productId = Number(match && match?.params?.productId);

  if (!productId) {
    logger.error('Invalid route');
    return null;
  }

  if (sizes.length) {
    return (
      <ul className={classNames(s.list, className)}>
        {sizes.map((size) => {
          const isSelected = selectedSizesIds.includes(size.id);

          return (
            <li
              key={size.id}
              className={s.item}
            >
              <Button
                className={classNames(
                  s.button,
                  { [s.buttonStateActive]: isSelected },
                )}
                theme="secondary"
                onClick={() => onSelectSize(size.id)}
              >
                {size.name}
              </Button>
            </li>
          );
        })}
      </ul>
    );
  }

  return null;
};
